import { render } from "./DataInput.vue?vue&type=template&id=12c0261f&scoped=true"
import script from "./DataInput.vue?vue&type=script&lang=js"
export * from "./DataInput.vue?vue&type=script&lang=js"

import "./DataInput.vue?vue&type=style&index=0&id=12c0261f&lang=css"
import "./DataInput.vue?vue&type=style&index=1&id=12c0261f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c0261f"]])

export default __exports__